namespace Portico.Services {

	import pme = Portico.Models.Enterprise;
	import pmg = Portico.Models.Gateway;
	import psga = apigateway.client;
	import psgm = apigateway.models;

    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

	export interface IEmailService {
		isUnsubscribed(email: string): angular.IPromise<boolean>;
		send(emailRequest: pme.EmailRequest, checkUnsubscribe?: boolean): angular.IPromise<boolean>;
		unsubscribe(accountId: number, email: string, userId: number, username: string): angular.IPromise<boolean>;
		unsubscribeV2(email: string, sourceName: string): angular.IPromise<boolean>;
    }

    @Service('app', 'emailService')
	@Inject('$q', 'EdgeEmailApi')
    export class EmailService implements IEmailService {
		constructor(
			private $q: angular.IQService,
			private edgeEmailApi: psga.EdgeEmailApi,
        ) { }

		isUnsubscribed(email: string): angular.IPromise<boolean> {
			return this.$q.when(this.edgeEmailApi.emailIsUnsubscribed({ email }).then((response) => {
				return response.data.data;
			}));
		}

		send(emailRequest: pme.EmailRequest, check: boolean = true): angular.IPromise<boolean> {
			const request = {
				check,
				email: {
					contact: {
						emailAddress: emailRequest.recipientAddress,
						firstName: emailRequest.recipientFirstName,
						lastName: emailRequest.recipientLastName
					},
					memberNumber: null,
					parameters: emailRequest.parameters,
					fromName: emailRequest.senderName || emailRequest.senderAddress,
					fromAddress: emailRequest.senderAddress,
					emailName: emailRequest.templaterName,
					deliveryType: 'triggered',
					messageContentType: pmg.MessageContentType.Html,
					tag: null
				}
			} as psgm.SendRequestModel;

			return this.$q.when(this.edgeEmailApi.emailSend(request).then((response) => {
				return response.data.data;
            }));
        }

		unsubscribe(accountId: number, email: string, userId: number, username: string): angular.IPromise<boolean> {
			return this.$q.when(this.edgeEmailApi.emailUnsubscribe({ accountId, email, userId, username }).then((response) => {
				return response.data.data;
			}));
		}

		unsubscribeV2(email: string, sourceName: string):  angular.IPromise<boolean> {
			return this.$q.when(this.edgeEmailApi.unsubscribeUnsubscribeBySourceName({ email, sourceName }).then((response: any) => {
				return response.data.data as boolean;
			}));
		}
    }
}